import styled, { keyframes } from "styled-components";
import { theme } from "../../styles/theme";

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
`;

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid ${theme.colors.gray};
  border-top-color: ${theme.colors.primary};
  border-radius: 50%;
  animation: ${rotate} 1s linear infinite;
`;

const LoadingText = styled.p`
  margin-top: 1.5rem;
  font-size: ${theme.fontSize.lg};
  color: ${theme.colors.gray};
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const Logo = styled.div`
  margin-bottom: 2rem;
  font-size: ${theme.fontSize["3xl"]};
  font-weight: 700;
  background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.secondary} 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

interface RouteLoaderProps {
  message?: string;
  showLogo?: boolean;
}

export function RouteLoader({
  message = "Carregando...",
  showLogo = false
}: RouteLoaderProps) {
  return (
    <Container role="status" aria-live="polite">
      {showLogo && <Logo>Senne Liquor</Logo>}
      <Spinner aria-hidden="true" />
      <LoadingText>{message}</LoadingText>
    </Container>
  );
}

export default RouteLoader;
